import { Component, Input, OnInit } from '@angular/core';
import { observable, computed } from 'mobx-angular';
import {
  TaskSupplierScheduleSource,
  TaskSupplierScheduleStepStore,
  TaskSupplierScheduleStore,
} from './task-supplier-schedule-store';

interface Step {
  name: string;
  schedule: TaskSupplierScheduleStepStore;
}

@Component({
  selector: 'task-supplier-schedule-timeline',
  templateUrl: './task-supplier-schedule-timeline.component.html',
  styleUrls: ['./task-supplier-schedule-timeline.component.scss'],
})
export class TaskSupplierScheduleTimelineComponent implements OnInit {
  @Input() @observable taskSupplierScheduleStore: TaskSupplierScheduleStore;

  @Input() hideDropOff: Boolean = false;

  @computed public get steps(): Step[] {
    return this.taskSupplierScheduleStore
      ? [
          {
            name: 'Collection',
            schedule: this.taskSupplierScheduleStore.pickUp,
          },
          // {
          //     name: null,
          //     schedule: null
          // },
          {
            name: 'Delivery',
            schedule: this.taskSupplierScheduleStore.dropOff,
          },
        ]
      : [];
  }

  ngOnInit() {}
}
